import { BaseResponse } from '../../../../../../../types/api/api.types';
import { COMMERCIAL_ENDPOINTS } from '../../../../../../../utils/api/endpoints/commercialEndpoints';

const ENABLE_PREFIX = '[enableCommercialQuery]';

export const ENABLE_COMMERCIAL_QUERY_KEY = 'ENABLE_COMMERCIAL';

export const enableCommercialQuery = async (commercialId: number) => {
  console.log(ENABLE_PREFIX, `Enabling Commercial...`);

  const response = await COMMERCIAL_ENDPOINTS.enable(commercialId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(ENABLE_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(ENABLE_PREFIX, `Enabled Commercial.`);
  return json as BaseResponse;
};

const DISABLE_PREFIX = '[disableCommercialQuery]';

export const DISABLE_COMMERCIAL_QUERY_KEY = 'DISABLE_COMMERCIAL';

export const disableCommercialQuery = async (commercialId: number) => {
  console.log(DISABLE_PREFIX, `Disabling Commercial...`);

  const response = await COMMERCIAL_ENDPOINTS.disable(commercialId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(DISABLE_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(DISABLE_PREFIX, `Disabled Commercial.`);
  return json as BaseResponse;
};
